import { render, staticRenderFns } from "./SStoreBasic.vue?vue&type=template&id=c0731958"
import script from "./SStoreBasic.vue?vue&type=script&lang=js"
export * from "./SStoreBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports